import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocuments = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 21,
			cy: 21,
			r: 21,
			fill: "#F0EEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31 18V24C31 26.5 30.5 28.25 29.38 29.38L23 23L30.73 15.27C30.91 16.06 31 16.96 31 18Z",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.73 15.27L15.27 30.73C12.26 30.04 11 27.96 11 24V18C11 13 13 11 18 11H24C27.96 11 30.04 12.26 30.73 15.27Z",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.3795 29.38C28.2495 30.5 26.4995 31 23.9995 31H17.9995C16.9595 31 16.0595 30.91 15.2695 30.73L22.9995 23L29.3795 29.38Z",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 18,
			cy: 18,
			r: 2,
			fill: "#7548F0"
		})
	]
});
export default SvgDocuments;
